export default __webpack_public_path__ + "static/logo-ca6b1babb126e689172d1473bc1594f9.svg";